import React from 'react';

import Spinner from 'click-controls/controls/spinner';

export interface IProps extends React.PropsWithChildren {
  className?: string;
  isLoading?: boolean;
  spinnerText?: string;
}

const ClickDialogBody: React.FC<IProps> = React.memo(
  ({ children, className: pClassName, isLoading, spinnerText }) => {
    const bodyClass = React.useMemo<string>(() => {
      return ['py-2 shrink overflow-y-visible'].addNotEmpty(pClassName).toClassNames(); //ideally want this overflow auto but dropdowns don't go on top then
    }, [pClassName]);

    const content = isLoading ? <Spinner message={spinnerText} /> : children;

    return <div className={bodyClass}>{content}</div>;
  }
);

ClickDialogBody.displayName = 'ClickDialogBody';

export default ClickDialogBody;
